import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { IError } from "itsf-ui-common";
import { useStancerPaymentIframe } from "./useStancerPaymentIframe";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { Box, Checkbox, FormControlLabel } from "@mui/material";

interface IParams {
    validatePaymentApiRoute: string;
    iframePaymentApiRoute: string;
    allowSaveCard?: boolean;
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const StancerPaymentIframe = (props: IParams) => {
    const { validatePaymentApiRoute, iframePaymentApiRoute, allowSaveCard, successCallback, errorCallback } = props;
    const { t } = useTranslation("payment");
    const { classes } = useStyle();

    const {
        iframeKey,
        getIFrame,
        iframeFetchState: { isLoading, error },
        hpp,
        wouldSaveCard,
        toggleWouldSaveCard,
    } = useStancerPaymentIframe({
        validatePaymentApiRoute,
        iframePaymentApiRoute,
        successCallback,
        errorCallback,
    });

    return (
        <HandleErrorAndLoading error={error} isLoading={isLoading} retryFetch={getIFrame}>
            {hpp && (
                <Box alignItems="center" display="flex" flexDirection="column">
                    <iframe
                        className={classes.iframe}
                        id="target-iframe"
                        key={iframeKey}
                        src={hpp.url}
                        title={t("paymentIframe")}
                    />
                    {Boolean(allowSaveCard) && (
                        <FormControlLabel
                            className={classes.saveCard}
                            control={
                                <Checkbox
                                    color="primary"
                                    id="save-card"
                                    value={wouldSaveCard}
                                    onChange={toggleWouldSaveCard}
                                />
                            }
                            label={t("saveCard")}
                        />
                    )}
                </Box>
            )}
        </HandleErrorAndLoading>
    );
};
